import { Component } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyService } from '../../../services/company.service';
import { ServicegroupService } from '../../../services/servicegroup.service';
import { IServiceGroup } from 'projects/serviceportal/src/app/interfaces/serviceGroup';
import { AsyncPipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IUser } from '../../../interfaces/user';
import { Observable } from 'rxjs';

enum UIState {
  list = 'list',
  create = 'create',
  edit = 'edit',
  modify = 'modify',
}
@Component({
    selector: 'app-servicegroup-page',
    templateUrl: './servicegroup-page.component.html',
    styleUrls: ['./servicegroup-page.component.scss'],
    imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectComponent,
    AsyncPipe
],
})
export class ServicegroupPageComponent {
  uiState = UIState.edit;

  companies$;
  coreusers$: Observable<IUser[]>;
  form;
  servicegroups$: Observable<IServiceGroup[]>;

  selectedServiceGroupId: number;

  constructor(
    private readonly userService: UserService,
    private readonly companyService: CompanyService,
    private readonly serviceGroupService: ServicegroupService,
    private readonly formBuilder: UntypedFormBuilder,
  ) {
    this.companies$ = companyService.companies$;
    this.coreusers$ = userService.usersWithCompany$;
    this.servicegroups$ = serviceGroupService.serviceGroupsChanged$;

    this.form = formBuilder.group({
      Id: [''],
      Name: ['', Validators.required],
      Users: [''],
      Companies: [''],
    });
  }

  private getFormAsServiceGroup(): IServiceGroup {
    return {
      name: this.form.get('Name').value,
      userIds: this.form.get('Users').value,
      companyIds: this.form.get('Companies').value,
    };
  }

  private getFormAsServiceGroupWithId(): IServiceGroup {
    return {
      id: this.form.get('Id').value,
      name: this.form.get('Name').value,
      userIds: this.form.get('Users').value,
      companyIds: this.form.get('Companies').value,
    };
  }

  onSubmit() {
    // new user
    if (this.selectedServiceGroupId === null) {
      this.serviceGroupService.createServiceGroup(this.getFormAsServiceGroup()).then(
        () => {
          this.reloadServiceGroups();
        },
        () => {},
      );
    } else {
      // editing existing user
      this.serviceGroupService.patchServiceGroup(this.getFormAsServiceGroupWithId()).then(
        () => {
          this.reloadServiceGroups();
        },
        () => {},
      );
    }

    this.uiState = UIState.edit;
  }

  edit() {
    if (this.uiState === UIState.edit) {
      this.uiState = UIState.list;
    } else {
      this.uiState = UIState.edit;
    }
  }

  createNewServiceGroup() {
    this.uiState = UIState.create;
    this.selectedServiceGroupId = null;
    this.form.patchValue({
      Name: '',
      Users: '',
      Companies: '',
    });
  }

  deleteServiceGroup(servicegroup: IServiceGroup) {
    if (confirm('Confirm deletion of: ' + servicegroup.name)) {
      this.serviceGroupService.deleteServiceGroup(servicegroup).then(
        () => {
          this.reloadServiceGroups();
        },
        () => {},
      );
    }
  }

  modifyServiceGroup(serviceGroup: IServiceGroup) {
    this.uiState = UIState.modify;
    this.selectedServiceGroupId = serviceGroup.id;
    this.form.patchValue({
      Id: serviceGroup.id,
      Name: serviceGroup.name,
      Companies: serviceGroup.companyIds,
      Users: serviceGroup.userIds,
    });
  }

  cancelNewUser() {
    this.uiState = UIState.edit;
  }

  private reloadServiceGroups() {
    this.serviceGroupService.reloadServiceGroups();
  }
}
